export default "__VITE_ASSET__D17RN4Ca__"